/* Reusable USA display adapter for Moxie's "Descuento de producto Front" integration. */
(function () {
  'use strict';

  var contexts = new WeakMap();

  function getView(product, priceElement, isProductPage) {
    if (!product || !priceElement ||
        !priceElement.matches('.t4s-product-price, .t4s-product-price [data-product-price]') ||
        priceElement.closest('.t4s-product-quick-view, #t4s-mini_cart, #CartPageForm')) return null;
    var root = priceElement.closest('[data-product-featured]');
    if (root) {
      var settings = JSON.parse(root.getAttribute('data-product-featured'));
      if (String(settings.id) === String(product.id).split('/').pop() &&
          (settings.isMainProduct === true ||
           (settings.isQuickShopForm === true && root.matches('.t4s-product-quick-shop')))) {
        return { root: root, detail: true };
      }
    }
    if (!isProductPage && !priceElement.closest('.t4s-product-quick-shop') &&
        priceElement.closest('.t4s-product-wrapper') && priceElement.closest('.t4s-product')) {
      return { root: priceElement.closest('.t4s-product'), detail: false };
    }
    return null;
  }

  function isTargetOffer(product, offer) {
    if (!product || !offer) return false;

    var currency = product.variants && product.variants.edges &&
      product.variants.edges[0] && product.variants.edges[0].node.priceV2;
    if (!currency || currency.currencyCode !== 'USD') return false;

    var percentage = Number(offer.percentage);
    if (offer.valueType !== 'percent' ||
        ['no_condition', 'compare_at_price', 'best_discount'].indexOf(offer.discountBehavior) === -1 ||
        !Number.isFinite(percentage) || percentage <= 0 || percentage > 100) return false;

    // Follow the actual offer selected by Front in any of its three registries.
    var scope = null;
    if (Array.isArray(window.colletions_in_offer) && window.colletions_in_offer.indexOf(offer) !== -1) {
      scope = 'specific_collections';
    } else if (Array.isArray(window.products_in_offer) && window.products_in_offer.indexOf(offer) !== -1) {
      scope = 'specific_products';
    } else if (Array.isArray(window.general_offer) && window.general_offer.indexOf(offer) !== -1) {
      scope = 'all';
    }
    if (!scope || !Array.isArray(window.promotions)) return false;

    // Match the selected offer to active metadata; never select or rank campaigns here.
    return window.promotions.some(function (campaign) {
      return campaign.type === 'product_discount' && campaign.status === 'ACTIVE' &&
        campaign.conditionType === scope &&
        campaign.valueType === offer.valueType &&
        Number(campaign.percentage) === percentage &&
        campaign.discountBehavior === offer.discountBehavior &&
        campaign.client && campaign.client.elegibility === 'all' && (
        (scope === 'all' && offer.handle === 'all') ||
        (scope === 'specific_products' && offer.id === product.id &&
          Array.isArray(campaign.products) && campaign.products.some(function (item) {
            return item.id === product.id;
          })) ||
        (scope === 'specific_collections' && Array.isArray(campaign.collections) &&
          product.collections && Array.isArray(product.collections.edges) &&
          campaign.collections.some(function (collection) {
          return collection.id && collection.handle === offer.handle &&
            product.collections.edges.some(function (entry) {
              return entry.node && entry.node.id === collection.id &&
                entry.node.handle === collection.handle;
            });
        })));
    });
  }

  function plainPriceNode(element) {
    return element && element.childNodes.length === 1 &&
      element.firstChild.nodeType === 3 ? element.firstChild : null;
  }

  function usdText(amount) {
    return '$' + amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function pricingProduct(context) {
    if (!context.view.detail) return context.product;
    var root = context.view.root;
    var control = root.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    var script = root.querySelector('script.pr_variants_json');
    if (!control || !script || !control.value) return context.product;
    var variants = JSON.parse(script.textContent);
    var variant = variants.find(function (item) { return String(item.id) === control.value; });
    if (!variant || !Number.isSafeInteger(variant.price) || variant.price < 0) return null;
    var node = Object.assign({}, context.product.variants.edges[0].node, {
      id: 'gid://shopify/ProductVariant/' + variant.id,
      priceV2: { amount: (variant.price / 100).toFixed(2), currencyCode: 'USD' },
      compareAtPriceV2: variant.compare_at_price == null ? null : {
        amount: (variant.compare_at_price / 100).toFixed(2), currencyCode: 'USD'
      }
    });
    return Object.assign({}, context.product, { variants: { edges: [{ node: node }] } });
  }

  function observe(context) {
    if (context.observer && context.price.isConnected) {
      context.observer.observe(context.price, { childList: true, characterData: true, subtree: true });
    }
  }

  function priceAmounts(product, offer) {
    var variant = product.variants.edges[0].node;
    var price = Number(variant.priceV2.amount);
    var compareAt = variant.compareAtPriceV2 ? Number(variant.compareAtPriceV2.amount) : 0;
    return {
      base: offer.discountBehavior === 'best_discount' && compareAt > price ? compareAt : price,
      nativeSale: offer.discountBehavior === 'compare_at_price' && compareAt > price
    };
  }

  async function format(context, restoreThemePrice) {
    var version = ++context.version;
    if (!isTargetOffer(context.product, context.offer) ||
        !getView(context.product, context.price, context.view.detail)) return;
    var product = pricingProduct(context);
    if (!product || typeof window.calculateOffer !== 'function') return;
    var amounts = priceAmounts(product, context.offer);
    // Front deliberately skips an already discounted variant in this mode.
    if (amounts.nativeSale) return;
    var basePrice = amounts.base;
    var discountedPrice = await window.calculateOffer(product, context.offer);
    if (version !== context.version || contexts.get(context.price) !== context ||
        !isTargetOffer(context.product, context.offer) ||
        !getView(context.product, context.price, context.view.detail) ||
        !context.price.isConnected || !Number.isFinite(basePrice) || basePrice < 0 ||
        typeof discountedPrice !== 'number' || !Number.isFinite(discountedPrice) ||
        discountedPrice < 0 || discountedPrice > basePrice) return;

    var originalNode = plainPriceNode(context.price.querySelector(':scope > del'));
    var discountedNode = plainPriceNode(context.price.querySelector(':scope > ins'));
    if ((!originalNode || !discountedNode) && !restoreThemePrice) return;
    if (context.observer) context.observer.disconnect();
    try {
      if (!originalNode || !discountedNode) {
        var del = document.createElement('del');
        var ins = document.createElement('ins');
        del.textContent = usdText(basePrice);
        ins.textContent = usdText(discountedPrice);
        context.price.replaceChildren(del, ins);
      } else {
        originalNode.nodeValue = usdText(basePrice);
        discountedNode.nodeValue = usdText(discountedPrice);
      }
      if (context.badge && !context.price.querySelector(':scope > .discount_widget_app_badge_pdp')) {
        context.price.appendChild(context.badge.cloneNode(true));
      }
    } finally {
      observe(context);
    }
  }

  function install() {
    var original = window.renderPriceOffer;
    if (typeof original !== 'function' || original.muUsaCardPriceFormat) return;
    if (typeof window.calculateOffer !== 'function') return;

    // Confirm both functions belong to the Front app embed before wrapping either name.
    var frontEmbed = Array.prototype.some.call(document.querySelectorAll('.shopify-app-block script'), function (script) {
      var source = script.textContent;
      return source.indexOf('window.colletions_in_offer') !== -1 &&
        source.indexOf(original.toString()) !== -1 &&
        source.indexOf(window.calculateOffer.toString()) !== -1;
    });
    if (!frontEmbed) return;

    var wrapped = async function (product, priceElement, offer, isProductPage) {
      var previous = priceElement && contexts.get(priceElement);
      if (previous) {
        previous.version++;
        if (previous.observer) previous.observer.disconnect();
        contexts.delete(priceElement);
      }
      var previousDel = priceElement && priceElement.querySelector(':scope > del');
      var previousIns = priceElement && priceElement.querySelector(':scope > ins');
      var args = Array.prototype.slice.call(arguments);
      try {
        var selectedView = getView(product, priceElement, isProductPage);
        if (selectedView && selectedView.detail && isTargetOffer(product, offer)) {
          // Let Front evaluate its original rule against the variant actually selected.
          var selectedProduct = pricingProduct({ product: product, view: selectedView });
          if (selectedProduct) args[0] = selectedProduct;
        }
      } catch (error) {}
      var result = await original.apply(this, args);
      try {
        var view = getView(product, priceElement, isProductPage);
        var renderedDel = priceElement && priceElement.querySelector(':scope > del');
        var renderedIns = priceElement && priceElement.querySelector(':scope > ins');
        var eligible = view && isTargetOffer(product, offer);
        var replaced = renderedDel && renderedIns && renderedDel !== previousDel && renderedIns !== previousIns;
        var nativeSkipped = eligible && view.detail && priceAmounts(args[0], offer).nativeSale;
        // A native sale stays untouched, but its form can later switch to a non-sale variant.
        if (eligible && (replaced || nativeSkipped)) {
          var badge = priceElement.querySelector(':scope > .discount_widget_app_badge_pdp');
          if (!badge && nativeSkipped) {
            badge = document.createElement('span');
            badge.className = 'discount_widget_app_badge_pdp';
            badge.textContent = offer.percentage + '%';
            badge.style.position = 'initial';
          }
          var context = { product: product, offer: offer, price: priceElement, view: view,
            badge: badge ? badge.cloneNode(true) : null, version: 0, observer: null };
          contexts.set(priceElement, context);
          await format(context, false);
          if (view.detail && window.MutationObserver) {
            context.observer = new MutationObserver(function () {
              // Kalles replaces these price nodes when a size/color changes.
              format(context, true).catch(function () {});
            });
            observe(context);
          }
        }
      } catch (error) {
        // A presentation failure must never interrupt the app's product scan.
      }
      return result;
    };
    wrapped.muUsaCardPriceFormat = '2026-10-15.1';
    window.renderPriceOffer = wrapped;
  }

  // Deferred loading runs after the app's inline definitions, before its initial scan.
  install();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', install, { once: true });
  }
})();
